import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'toastNotifications';

export const actionTypes = {
  SHOW_NOTIFICATION: `${FEATURE_NAME}/SHOW_NOTIFICATION`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
